import { useState, useMemo, useContext } from 'react';
import { useHistory } from "react-router-dom";

const useJourneyHook = () => {
  const history = useHistory();

  const routeJourney = (journey) =>{
    history.push(`/journey/portal/page/${journey.id}`);
  }

  return {
    routeJourney
  }
}

export {useJourneyHook};